import { render, staticRenderFns } from "./screen-ephemeris.vue?vue&type=template&id=418ad671&scoped=true"
import script from "./screen-ephemeris.vue?vue&type=script&lang=ts"
export * from "./screen-ephemeris.vue?vue&type=script&lang=ts"
import style0 from "./screen-ephemeris.vue?vue&type=style&index=0&id=418ad671&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418ad671",
  null
  
)

export default component.exports